import {
  CHART_TYPE_AREA,
  CHART_TYPE_BAR,
  CHART_TYPE_DOUGHNUT,
  CHART_TYPE_HORIZONTAL_BAR,
  CHART_TYPE_LINE,
  CHART_TYPE_PIE,
  CHART_TYPE_POLAR_AREA,
  CHART_TYPE_PYRAMID,
  CHART_TYPE_RADAR
} from "../chart/constants";

export const VIEWER_TABLE_TYPE = "table";
export const VIEWER_MAP_TYPE = "map";
export const VIEWER_CHART_TYPES = [
  CHART_TYPE_BAR,
  CHART_TYPE_HORIZONTAL_BAR,
  CHART_TYPE_LINE,
  CHART_TYPE_AREA,
  CHART_TYPE_DOUGHNUT,
  CHART_TYPE_PIE,
  CHART_TYPE_RADAR,
  CHART_TYPE_POLAR_AREA,
  CHART_TYPE_PYRAMID
];

export const NUMERIC_COLUMN_TYPES = ["Edm.Decimal", "Edm.Single", "Edm.Double", "Edm.Int16", "Edm.Int32", "Edm.Int64"];
